import { render, staticRenderFns } from "./VIdle.vue?vue&type=template&id=1d65ff7a&"
import script from "./VIdle.vue?vue&type=script&lang=js&"
export * from "./VIdle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports